/* Form Page to create a Day by giving it a number and date */
import React, { useState } from "react";

import DatePicker from "react-datepicker";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import TopBox from "../../../components/TopBox";
import { useRedirect } from "../../../hooks/Redirect";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { formatScheduleDate } from "../../../utils/date";

import "react-datepicker/dist/react-datepicker.css";
import styles from "../../../styles/PostCreateEditForm.module.css";
import btnStyles from "../../../styles/Button.module.css";
import toast from "react-hot-toast"

const DayCreateForm2 = () => {
  const host = useHostName();
  useRedirect();
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episodeid");
  const episodeTitle = params.get("episodeTitle");

  const [errors, setErrors] = useState({});
  const [startDate, setStartDate] = useState("");

  const [postData, setPostData] = useState({
    day: "",
  });
  const { day } = postData;

  const history = useHistory();

  const handleDate = (date) => {
    const newdate = formatScheduleDate(date);
    setStartDate(newdate);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const nextValue = name === "day" ? value.replace(/\D/g, "") : value;
    setPostData({
      ...postData,
      [name]: nextValue,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    // Validate name
    if (!day || !/^\d+$/.test(day)) {
      toast.error("An Day Number Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    formData.append("day", day);
    formData.append("date", startDate);
    formData.append("is_second_unit", true);

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const res = await axiosReq.post("/days/", formData);
        if (res?.success === false || res?.status === false) {
          throw res?.error || new Error("Failed to create day");
        }
        toast.success(`Day Added`);
        history.goBack();
      } else {
        const res = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/days/create/`,
          {
            day: day,
            date: startDate,
            episode: epi,
            is_second_unit: true,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        if (res?.success === false || res?.status === false) {
          throw res?.error || new Error("Failed to create day");
        }
        toast.success(`Day Created Successfully!`);
        history.goBack();
      }
    } catch (err) {
      console.log(err);
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          err?.message ||
          "Failed to create day."
      );
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Create
      </Button>
    </div>
  );

  return (
    <div>
    <TopBox 
     second="2ND UNIT - SCHEDULE"
     title="Create Day" 
     episodeTitle={`Episode ${episodeTitle}`} />
    <Button
      className={`${btnStyles.Button} ${btnStyles.Blue} my-1`}
      onClick={() => history.goBack()}
    >
      Back
    </Button>
    <Row className="px-3">
    <Col xs={12} md={{span: 8, offset: 2 }} >
    <h3 className="text-center">2nd Unit - Create Day</h3>
    <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
    <Form className={`${styles.White} px-3`} onSubmit={handleSubmit}>
    <Row className="text-center">
    <Col xs={6} className="pt-2 p-md-2 d-flex justify-content-center ">
        <Form.Group controlId="day" className={`${styles.Width2}`}>
            <Form.Label className={`${styles.BoldScene}`} >Day</Form.Label>
            <Form.Control 
            type="number"
            inputMode="numeric"
            name="day"
            value={day}
            className={`${styles.Input}`}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.day?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
            {message}
            </Alert>
        ))}
      </Col> 
    <Col xs={6} className="pt-2 px-0 mx-0">
    <div>
    <p className={`${styles.BoldScene} text-center`}>Date</p>
    </div>
    <div className="pt-2 d-flex justify-content-center px-0">
    <Form.Group controlId="date" className={`${styles.Width95} px-0`} >
              <Form.Label className={`${styles.BoldScene}`}></Form.Label>
              <DatePicker 
                className={`${styles.InputD}`}
                  value={startDate}
                onChange={(date) => handleDate(date) }
                />
          </Form.Group>
          {errors?.date?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
    </div>
    </Col> 
    </Row>
    {/* buttons */}
    <Row>
        <Col>
        <div className="my-3" >{buttons} </div>
        </Col>
    </Row>
    </Form>
    <Row>
    <Col sm={2} className="d-none d-sm-block" >
    </Col> 
    <Col xs={12} sm={8} >
    <hr/>
    </Col>
    </Row>
    </Col>
    </Row>
    </div>
  );
};

export default DayCreateForm2;
